import { type ReactNode } from 'react'
import cx from 'classnames'
import { RawButton } from '@/components/Button'
import { IconButton } from '@/components/IconButton'
import { type IconName } from '@/components/Icon'
import styles from './ScheduleCallComposerAction.module.css'

export {
  ScheduleCallCalloutContainer,
  ScheduleCallLeadingActionContainer,
} from './ScheduleCallComposerActionContainer'

interface ScheduleCallComposerCalloutProps {
  children: ReactNode
  onPress?: () => void
}

export function ScheduleCallComposerCallout({
  children,
  onPress,
}: ScheduleCallComposerCalloutProps) {
  if (onPress) {
    return (
      <RawButton
        className={cx(styles.callout, styles.calloutAction)}
        onPress={onPress}
      >
        {children}
      </RawButton>
    )
  }

  return <div className={styles.callout}>{children}</div>
}

interface ScheduleCallComposerIconButtonProps {
  iconName: IconName
  iconLabel: string
  onPress?: () => void
  isDisabled?: boolean
  testId?: string
}

export function ScheduleCallComposerIconButton({
  iconName,
  iconLabel,
  onPress,
  isDisabled,
  testId,
}: ScheduleCallComposerIconButtonProps) {
  return (
    <IconButton
      sm
      name={iconName}
      label={iconLabel}
      onPress={onPress}
      isDisabled={isDisabled}
      testId={testId}
    />
  )
}
